import React, { Component } from "react";
import Lightbox from "react-image-lightbox";

import "./Wykonawstwo.css";
import Aux from "../../../../hoc/Aux/Aux";
import imageSection4_1 from "../../../../img/architektura/Rysunek10.jpg";

const images = [imageSection4_1];

export default class Wykonawstwo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
      imagePadding: 100
    };
  }
  render() {
    const { photoIndex, isOpen } = this.state;

    return (
      <Aux>
        <div className="card-background row p-5">
          <div className="col-md lead mt-3">
            W przypadku, gdy zależy na:
            <ul>
              <li>fachowym wykonaniu usługi</li>
              <li>realizacji wnętrza</li>
              <li>zachowaniu charakteru projektu</li>
              <li>kompleksowym wykonawstwie „pod klucz”</li>
              <li>organizacji czasu pracy</li>
              <li>kupnie i dostawie materiałów na budowę</li>
            </ul>
          </div>
          <div className="col-md lead mt-3">
            Wyborem będzie wykonawstwo:
            <ul>
              <li>pewność w realizacji ustalonego stylu</li>
              <li>zakres ustalony w kosztorysie</li>
              <li>bezpieczeństwo zawarte w umowie</li>
              <li>dostawy i zwroty materiałów</li>
              <li>optymalny harmonogram prac i dostaw</li>
              <li>gwarancja, jakości prac</li>
            </ul>
          </div>
          <div className="row pt-4">
            <div className="image-lightbox col-lg-4 m-auto p-1 border border-dark rounded">
              <img
                src={imageSection4_1}
                alt=""
                className="img-fluid"
                onClick={() => this.setState({ isOpen: true, photoIndex: 0 })}
              />
            </div>
          </div>
        </div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
      </Aux>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Architecture/Services/Wykonawstwo/Wykonawstwo.js